import { NumberInput, useTranslate } from "react-admin";

export const InspectionIntervalInputs = () => {
    const translate = useTranslate();

    return (
        <>
            <NumberInput
                title={translate("equip.vdeInspectionIntervalMonths")}
                label="equip.vdeInspectionIntervalMonths"
                source="vdeInspectionIntervalMonths"
                helperText="equip.noInspectionInterval"
            />
            <NumberInput
                title={translate("equip.uvvInspectionIntervalMonths")}
                label="equip.uvvInspectionIntervalMonths"
                source="uvvInspectionIntervalMonths"
                helperText="equip.noInspectionInterval"
            />
        </>
    );
};

export const clearInspectionIntervalsForMassProduct = (data) => {
    if (data.isMassProduct) {
        data.vdeInspectionIntervalMonths = null;
        data.uvvInspectionIntervalMonths = null;
    }
};
